import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { WritingInterval } from '../../../Models';

export interface EditingPage {
  dateId: string | null;
  text: string;
  isChanged: boolean;
  writingIntervals: WritingInterval[];
}

export const initialState: IPageEditorState = {
  editableArticle: {
    dateId: null,
    text: '',
    isChanged: false,
    writingIntervals: [],
  },
  firstTimeVisit: true,
};

export interface IPageEditorState {
  readonly editableArticle: EditingPage;
  readonly firstTimeVisit: boolean;
}

type EditorActions = ActionType<typeof actions>;

const articleEditor = (state: Mutable<IPageEditorState> = initialState, action: EditorActions): IPageEditorState => {
  switch (action.type) {
    case getType(actions.updatePageEditorEditablePage): {
      state.editableArticle.text = action.payload.text;
      state.editableArticle.isChanged = true;
      state.editableArticle.writingIntervals = action.payload.writingIntervals;
      break;
    }
    case getType(actions.setPageEditorEditablePage): {
      const pageId = action.payload && action.payload.dateId;
      if (state.editableArticle.dateId !== pageId) {
        state.editableArticle = action.payload;
      }
      break;
    }
    case getType(actions.resetPageEditorState): {
      state.editableArticle = initialState.editableArticle;
      break;
    }
    case getType(actions.updatePageEditorFirstVisitState): {
      state.firstTimeVisit = action.payload;
      break;
    }
    case getType(actions.updatePageEditorStateFromExternalSource): {
      if (action.payload) {
        return {
          ...initialState,
          ...action.payload,
          editableArticle: {
            ...initialState.editableArticle,
            ...action.payload.editableArticle,
          },
        };
      }
    }
  }

  return state;
};

export default articleEditor;



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PageEditor/reducer.ts